module.exports = __webpack_public_path__ + "img/MassGIS_Oliver_NHESP_HabitatsEtc_1.c57646ac.png";